// components/FeatureRenderer/LocationSelector.jsx
import React from 'react';

const LocationSelector = ({ feature, value = {}, onChange }) => {
    const handleLocationChange = (field, fieldValue) => {
        onChange({
            ...value,
            [field]: fieldValue
        });
    };

    // Find field definitions
    const countryField = feature.uiConfig.fields.find(f => f.slug === 'country');

    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3">{feature.name}</h6>

            {countryField && (
                <div className="mb-3">
                    <label className="form-label fw-medium">
                        {countryField.name} <span className="text-danger">*</span>
                    </label>
                    <select
                        className="form-select"
                        value={value.country || countryField.default || ''}
                        onChange={(e) => handleLocationChange('country', e.target.value)}
                    >
                        <option value="">Select Country</option>
                        {countryField.options.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default LocationSelector;